import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNutPressingSm = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "nut_pressing-sm" }), /* @__PURE__ */ _jsxs("g", {
		id: "Layer_2",
		"data-name": "Layer 2",
		children: [
			/* @__PURE__ */ _jsx("path", {
				className: "icon-white",
				d: "M92.15,61.56a.44.44,0,0,0,0-.16h0l-.06-.15,0,0L92,61.1l0,0A.69.69,0,0,0,91.8,61L50.23,37a.71.71,0,0,0-.72,0L8.2,60.81a.69.69,0,0,0-.13.11l0,0-.07.1,0,0-.06.15h0a.47.47,0,0,0,0,.17h0v4.32a.73.73,0,0,0,.36.63l41.57,24a.76.76,0,0,0,.72,0L91.8,66.53a.73.73,0,0,0,.36-.63V61.56Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M92.63,61.51a.73.73,0,0,0,0-.22l0-.07a1,1,0,0,0-.09-.21l0-.06a1.1,1.1,0,0,0-.14-.18l0-.05a1.13,1.13,0,0,0-.23-.17l-41.57-24a1.17,1.17,0,0,0-1.2,0L8,60.4a1.13,1.13,0,0,0-.23.17l-.05.06a1.09,1.09,0,0,0-.13.17l0,.06a1.89,1.89,0,0,0-.09.21v0a.69.69,0,0,0,0,.25v4.38a1.2,1.2,0,0,0,.6,1l41.57,24a1.21,1.21,0,0,0,1.2,0L92,66.94a1.2,1.2,0,0,0,.6-1V61.51ZM92,61.1Zm-43,25v1.54L9.76,65.06V63.51ZM89,61.58,50.13,84.05,11,61.43,49.87,39Zm1.2,2.08v1.55L51.33,87.67V86.13Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M37.47,60.2l3.1,6.6a.9.9,0,0,0,.12.19l.06.09a1.76,1.76,0,0,0,.3.24l.09.05.23.08,11.55,1.82h.18a1.24,1.24,0,0,0,.37-.06l.11,0,.12-.06L62,64.3a1.2,1.2,0,0,0,.6-1V58.38a.11.11,0,0,1,0-.05,1.31,1.31,0,0,0-.06-.27l-3.14-6.71a1.23,1.23,0,0,0-.9-.68L47.09,48.88a1.22,1.22,0,0,0-.79.15L38,53.85l-.08,0a1.2,1.2,0,0,0-.26.24l-.06.09a1,1,0,0,0-.14.28.55.55,0,0,0,0,.17,1,1,0,0,0,0,.21v4.8A1.3,1.3,0,0,0,37.47,60.2ZM51.9,64.31v2.37l-9-1.42V62.89ZM40.11,55.38l7-4.06L57.53,53l2.36,5-7,4.05L42.47,60.4ZM54.3,66V64l5.94-3.43v2Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-outline",
				d: "M45.94,59.71a8.37,8.37,0,0,0,4.09,1,8.21,8.21,0,0,0,4-1c1.69-1,2.4-2.52,1.84-4h0a4.08,4.08,0,0,0-1.86-2,8.89,8.89,0,0,0-8.14,0,4.22,4.22,0,0,0-1.6,1.53A2.86,2.86,0,0,0,44,57.4,3.85,3.85,0,0,0,45.94,59.71Zm.45-3.35a2,2,0,0,1,.74-.65A5.84,5.84,0,0,1,50,55.05a6,6,0,0,1,2.89.67,1.77,1.77,0,0,1,.81.8c.19.51-.56,1-.79,1.12h0a6.57,6.57,0,0,1-5.74,0,1.68,1.68,0,0,1-.82-.85A.5.5,0,0,1,46.39,56.36Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M54.91,44.15a1.09,1.09,0,0,0-1.6-.49L51.2,45.09V37.57a1.2,1.2,0,1,0-2.4,0v7.51l-2.11-1.42a1.08,1.08,0,0,0-.92-.13,1,1,0,0,0-.68.61,1.41,1.41,0,0,0,.42,1.77l3.61,2.43.09.11a1.46,1.46,0,0,0,.26.18l.09,0a1.09,1.09,0,0,0,.3.07h.25a1.07,1.07,0,0,0,.46-.14l.11-.07h0l.11-.11.06-.07,3.65-2.47A1.42,1.42,0,0,0,54.91,44.15Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M50,19.57a1.2,1.2,0,0,0,1.2-1.2V14.53a1.2,1.2,0,0,0-2.4,0v3.84A1.2,1.2,0,0,0,50,19.57Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M50,27.25a1.2,1.2,0,0,0,1.2-1.2V22.21a1.2,1.2,0,0,0-2.4,0v3.84A1.2,1.2,0,0,0,50,27.25Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-highlight",
				d: "M50,34.93a1.2,1.2,0,0,0,1.2-1.2V29.89a1.2,1.2,0,0,0-2.4,0v3.84A1.2,1.2,0,0,0,50,34.93Z"
			})
		]
	})]
});
export default SvgNutPressingSm;
